module.exports = __webpack_public_path__ + "img/116.1967568f.png";